var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"root"},[_c('div',{staticClass:"container-shell"},[_c('div',{staticClass:"option"}),_c('div',{ref:"container",attrs:{"id":"container"}}),_c('div',{staticClass:"input"},[(!_vm.playing)?_c('button',{on:{"click":_vm.playBtnClick}},[_vm._v("播放")]):_c('button',{on:{"click":_vm.pause}},[_vm._v("停止")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }